import React from 'react';
import styles from '../../styles/components/question-recycling-bin/QuestionRecyclingBin.module.css';
import { ActionButton } from '@ax2/common/components/ActionButton';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import UUID from '@ax2/common/model/UUID';
import { getTemplateText } from '@ax2/common/helpers/template';
import parse from 'html-react-parser';

export interface QuestionRecyclingBinProps {
  questions: QuestionSchema[];
  onPutBack: (questionId: UUID) => void;
}

const QuestionRecyclingBin: React.FC<QuestionRecyclingBinProps> = ({
  questions,
  onPutBack,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {`Recycling Bin (${questions.length})`}
      </div>
      <div className={styles.content}>
        {questions.map(question => (
          <div key={question.id} className={styles.question}>
            <div className={styles.questionIcon}>Q-</div>
            <div className={styles.questionText}>
              {'content' in question &&
                parse(getTemplateText(question.content))}
            </div>
            <div className={styles.questionButton}>
              <ActionButton
                text="Put Back"
                type="primary"
                size="small"
                onClick={async () => onPutBack(question.id)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuestionRecyclingBin;
